const makeInitialState = () => {
  return {
    comment: ''
  };
};

export default makeInitialState;
